module.exports = __webpack_public_path__ + "img/american-coot.d7f42353.jpg";